'use client';

import { useState } from 'react';
import AkkaLink from '@commons/AkkaLink/AkkaLink';
import HtmlToJsx from '@commons/HtmlToJsx/HtmlToJsx';
import { usePathname } from 'next/navigation';
import { ChevronLeft } from '@icons';
import Overlay from '@commons/Overlay/Overlay';
import { useSiteConfig } from '@commons/SiteConfig';
import CookieSettings from '@commons/CookieSettings';

export default function SiteHeaderNavigation({ items, name = '', overlaySuffix = '', children }) {
  const pathname = usePathname();
  const { lang } = useSiteConfig();
  const [activeParent, setActiveParent] = useState(null);
  const overlayIdKey = overlaySuffix ? `${name}-${overlaySuffix}` : name;

  if (!items || items.length === 0) return null;

  const handleLinkClick = (e) => {
    document.querySelectorAll('.SiteHeader__Overlay[open]').forEach((dialog) => {
      dialog.close();
    });
  };

  return (
    <div className={`SiteHeader__navigation-wrapper ${name}`}>
      {/* Primary List */}
      <nav className="SiteHeader__navigation">
        {items.map((menuItem) => {
          const hasChildren = menuItem.children && menuItem.children.length > 0;
          return hasChildren ? (
            <button
              key={`menuItem--${menuItem.id}`}
              className="SiteHeader__navigation-drill-btn"
              onClick={(e) => {
                e.preventDefault();
                setActiveParent(menuItem);
                document.getElementById(`submenu-overlay-${overlayIdKey}`)?.showModal();
              }}
            >
              <HtmlToJsx html={menuItem.title} />
            </button>
          ) : (
            <AkkaLink
              key={`menuItem--${menuItem.id}`}
              href={menuItem.url}
              className={pathname === menuItem.url ? 'active' : ''}
              onClick={handleLinkClick}
            >
              <HtmlToJsx html={menuItem.title} />
            </AkkaLink>
          );
        })}
      </nav>

      {/* Secondary List */}
      <Overlay className="SiteHeader__Overlay SiteHeader__Overlay--submenu" id={`submenu-overlay-${overlayIdKey}`}>
        <nav className="SiteHeader__navigation SiteHeader__navigation--sub">
          <button
            className="SiteHeader__navigation-back-btn"
            onClick={() => {
              document.getElementById(`submenu-overlay-${overlayIdKey}`)?.close();
              setTimeout(() => setActiveParent(null), 400);
            }}
            style={{ visibility: activeParent ? 'visible' : 'hidden' }}
          >
            <ChevronLeft />
            {activeParent && <HtmlToJsx html={activeParent.title} />}
          </button>
          {activeParent?.children?.map((childItem) => (
            <AkkaLink
              key={`childItem--${childItem.id}`}
              href={childItem.url}
              className={pathname === childItem.url ? 'active' : ''}
              onClick={handleLinkClick}
            >
              <HtmlToJsx html={childItem.title} />
            </AkkaLink>
          ))}
        </nav>
        {children}
        <CookieSettings />
        <div className="SiteHeader__language-selector">
          <a
            href="https://visittelemark.com"
            className={`SiteHeader__language-link ${lang === 'en' ? 'is-inactive' : ''}`}
          >
            English
          </a>
          <span className="SiteHeader__language-separator"> / </span>
          <a
            href="https://www.visittelemark.no"
            className={`SiteHeader__language-link ${lang !== 'en' ? 'is-inactive' : ''}`}
          >
            Norsk
          </a>
        </div>
      </Overlay>
    </div>
  );
}
